import React, { useState, useEffect, useRef } from 'react';
import HeaderLogged from './components/header_logged';
import api from './api/client';
import './OrdersPackagesScan.css';
import OrderItemsPopup from './components/OrderItemsPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft, faPen, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

function OrdersPackagesPage() {
    
    const [barcodes, setBarcodes] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [shipDate, setShipDate] = useState(new Date().toISOString().split('T')[0]);
    const [packages, setPackages] = useState([]);
    const [stats, setStats] = useState({
        totalScanningMinutes: 0,
        avgPerPackageMinutes: 0
    });

    // Состояния для csv файлов
    const [uploading, setUploading] = useState(false);
    const [uploadResults, setUploadResults] = useState([]);
    const fileInputRef = useRef(null);

    // Состояния для синхронизации составов заказов из Veeqo после загрузки CSV
    const [veeqoSyncing, setVeeqoSyncing] = useState(false);
    const [veeqoSyncProgress, setVeeqoSyncProgress] = useState(0);
    const [veeqoSyncTotal, setVeeqoSyncTotal] = useState(0);
    const [veeqoSyncFound, setVeeqoSyncFound] = useState(0);

    //Поиск и фильтры для первой вкладки
    const [searchQuery, setSearchQuery] = useState('');
    const [filterService, setFilterService] = useState('All');
    const [filterStatus, setFilterStatus] = useState('All');
    const [sortField, setSortField] = useState(null); // 'order_date' | 'scanned_at'
    const [sortDir, setSortDir] = useState('asc'); // 'asc' | 'desc'
    const [assemblyStatuses, setAssemblyStatuses] = useState({}); // { order_number: status }
    const [amazonOrders, setAmazonOrders] = useState(new Set()); // order_numbers with amazon-shipped items
    
    // Реф для управления фокусом в textarea
    const textareaRef = useRef(null);

    // Новые состояния для отслеживания заказов
    const [activeTab, setActiveTab] = useState('scanner'); // 'scanner' или 'tracking'
    const [trackingData, setTrackingData] = useState([]);
    const [trackingLoading, setTrackingLoading] = useState(false);
    const [trackingStatusFilters, setTrackingStatusFilters] = useState([]);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState('all');
    const [trackingLastUpdated, setTrackingLastUpdated] = useState(null);

    // Новые состояния для поиска и фильтров на второй вкладке
    const [trackingSearchQuery, setTrackingSearchQuery] = useState('');
    const [filterTrackingWarehouseStatus, setFilterTrackingWarehouseStatus] = useState('All');
    const [filterTrackingCarrier, setFilterTrackingCarrier] = useState('All');

    // Флаг для управления автоматическим возвратом фокуса
    const [shouldRefocusTextarea, setShouldRefocusTextarea] = useState(true);

    //Для 3 вкладки
    // Новые состояния для вкладки застрявших посылок
    const [stuckPackages, setStuckPackages] = useState([]);
    const [stuckLoading, setStuckLoading] = useState(false);
    const [stuckDaysFilter, setStuckDaysFilter] = useState(1);
    const [stuckSearchQuery, setStuckSearchQuery] = useState('');
    const [stuckCarrierFilter, setStuckCarrierFilter] = useState('All');
    const [stuckWarehouseFilter, setStuckWarehouseFilter] = useState('All');
    const [stuckDateFrom, setStuckDateFrom] = useState('');
    const [stuckDateTo, setStuckDateTo] = useState('');
    const [stuckStats, setStuckStats] = useState({
        total: 0,
        stuck: 0,
        percentage: 0,
        by_carrier: {},
        by_day: {}
    });

    // SS Stock tab states
    const [ssStockData, setSsStockData] = useState([]);
    const [ssStockLoading, setSsStockLoading] = useState(false);
    const [ssStockSearch, setSsStockSearch] = useState('');
    const [ssStockBrandFilter, setSsStockBrandFilter] = useState('All');
    const [ssStockAddPopup, setSsStockAddPopup] = useState(false);
    const [ssStockBoxText, setSsStockBoxText] = useState('');
    const [ssStockSaving, setSsStockSaving] = useState(false);
    const [ssStockSaveMsg, setSsStockSaveMsg] = useState('');
    // Inline qty editing
    const [editingId, setEditingId] = useState(null);
    const [editingQty, setEditingQty] = useState('');
    // History popup
    const [historyPopup, setHistoryPopup] = useState(null); // { sku, items: [] } or null
    const [historyLoading, setHistoryLoading] = useState(false);
    // Попап подтверждения списания материалов при ручном увеличении set/wildmicr/fertilizer
    const [bagPopup, setBagPopup] = useState(null); // { item, newQty, diff, bag, info, error, busy }

    // Попап состава заказа: { orderNumber, trackingNumber, rows: [{order_number, tracking_number}], dates } или null
    const [orderPopup, setOrderPopup] = useState(null);
    const openOrderPopup = (orderNumber, trackingNumber, rows, dates) =>
        setOrderPopup({ orderNumber, trackingNumber, rows, dates });
    const navigateOrderPopup = ({ orderNumber, trackingNumber }) =>
        setOrderPopup(prev => ({ ...prev, orderNumber, trackingNumber }));


    // Загружаем пакеты при монтировании компонента и при изменении даты
    useEffect(() => {
        fetchPackages();
    }, [shipDate]);

    // При монтировании — проверяем незавершённый job из предыдущей сессии
    useEffect(() => {
        const savedJobId = localStorage.getItem('veeqoSyncJobId');
        if (!savedJobId) return;
        api.get(`/api/veeqo/sync-status/${savedJobId}`)
            .then(res => {
                if (res.data.success && res.data.status === 'running') {
                    startPollingJob(savedJobId, res.data.total);
                } else {
                    localStorage.removeItem('veeqoSyncJobId');
                }
            })
            .catch(() => localStorage.removeItem('veeqoSyncJobId'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Фокус на textarea при монтировании компонента
    useEffect(() => {
        if (textareaRef.current && activeTab === 'scanner') {
            textareaRef.current.focus();
        }
    }, [activeTab]);

    // Мок данные для отслеживания
    const generateMockTrackingData = (packagesList) => {
        if (!Array.isArray(packagesList)) return [];
        
        const statuses = [
            { status: 'Label Created', days: 0, movement: 'not_moving', description: 'Shipping label created, USPS awaiting item' },
            { status: 'In Transit', days: 1, movement: 'in_transit', description: 'Arrived at USPS facility' },
            { status: 'Out for Delivery', days: 2, movement: 'in_transit', description: 'Out for delivery' },
            { status: 'Delivered', days: 3, movement: 'delivered', description: 'Delivered to mailbox' },
            { status: 'Exception', days: 0, movement: 'not_moving', description: 'Delivery exception' },
            { status: 'Pending', days: 0, movement: 'not_moving', description: 'Pending acceptance' }
        ];
        
        return packagesList
            .filter(pkg => pkg.tracking_number) // Все пакеты с трекинг номером, не только сканированные
            .map(pkg => {
                const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
                const scanDate = pkg.scanned_at ? new Date(pkg.scanned_at) : new Date();
                const lastUpdate = new Date(scanDate);
                lastUpdate.setDate(lastUpdate.getDate() - randomStatus.days);
                
                return {
                    id: pkg.id,
                    order_number: pkg.order_number,
                    tracking_number: pkg.tracking_number,
                    service: pkg.service,
                    ship_date: pkg.ship_date,
                    order_date: pkg.order_date,
                    scanned_date: pkg.scanned_at,
                    last_update: lastUpdate.toISOString(),
                    tracking_status: randomStatus.status,
                    status_description: randomStatus.description,
                    movement: randomStatus.movement,
                    days_since_last_update: randomStatus.days,
                    estimated_delivery: new Date(scanDate.getTime() + (3 * 24 * 60 * 60 * 1000)).toISOString().split('T')[0],
                    warehouse_status: pkg.status || 'Not Scanned' // Добавляем статус склада
                };
            });
    };

    // Объединяем данные пакетов с данными трекинга (общая логика)
    const mergeTrackingResults = (packagesWithTracking, trackingResults) => {
        return packagesWithTracking.map(pkg => {
            const trackingInfo = trackingResults.find(t => t.tracking_number === pkg.tracking_number);

            if (trackingInfo) {
                const isError = trackingInfo.api_source === 'UPS_API_ERROR' ||
                    trackingInfo.api_source === 'NOT_FOUND' ||
                    trackingInfo.api_source === 'LOOKUP_ERROR';
                if (isError) {
                    return {
                        id: pkg.id, order_number: pkg.order_number,
                        tracking_number: pkg.tracking_number, service: pkg.service,
                        ship_date: pkg.ship_date, order_date: pkg.order_date,
                        scanned_date: pkg.scanned_at, last_update: pkg.updated_at,
                        tracking_status: trackingInfo.tracking_status || 'Tracking Unavailable',
                        status_description: trackingInfo.status_description || 'Tracking not available',
                        movement: 'not_moving', days_since_last_update: 0,
                        estimated_delivery: null, carrier: trackingInfo.carrier || 'USPS', is_delivered: false,
                        exception_code: null, exception_description: trackingInfo.status_description || null,
                        api_source: trackingInfo.api_source || 'ERROR',
                        warehouse_status: pkg.status || 'Not Scanned'
                    };
                }
                return {
                    id: pkg.id, order_number: pkg.order_number,
                    tracking_number: pkg.tracking_number, service: pkg.service,
                    ship_date: pkg.ship_date, order_date: pkg.order_date,
                    scanned_date: pkg.scanned_at, last_update: trackingInfo.last_update,
                    tracking_status: trackingInfo.tracking_status,
                    status_description: trackingInfo.status_description,
                    movement: trackingInfo.movement,
                    days_since_last_update: trackingInfo.days_stuck || 0,
                    estimated_delivery: trackingInfo.estimated_delivery,
                    carrier: trackingInfo.carrier, is_delivered: trackingInfo.is_delivered,
                    exception_code: trackingInfo.exception_code,
                    exception_description: trackingInfo.exception_description,
                    api_source: trackingInfo.api_source,
                    warehouse_status: pkg.status || 'Not Scanned'
                };
            }

            const savedStatus = pkg.tracking_status;
            const isDelivered = savedStatus === 'Delivered';
            return {
                id: pkg.id, order_number: pkg.order_number,
                tracking_number: pkg.tracking_number, service: pkg.service,
                ship_date: pkg.ship_date, order_date: pkg.order_date,
                scanned_date: pkg.scanned_at, last_update: pkg.updated_at,
                tracking_status: savedStatus || 'Pending',
                status_description: isDelivered ? 'Delivered' : 'Awaiting tracking information',
                movement: isDelivered ? 'delivered' : 'not_moving',
                days_since_last_update: 0, estimated_delivery: null,
                carrier: 'USPS', is_delivered: isDelivered,
                exception_code: null, exception_description: null,
                api_source: isDelivered ? 'DB_CACHE' : 'NO_DATA',
                warehouse_status: pkg.status || 'Not Scanned'
            };
        });
    };

    const applyTrackingResults = (mergedData) => {
        setTrackingData(mergedData);
        const uniqueStatuses = [...new Set(mergedData
            .filter(item => item.tracking_status &&
                item.api_source &&
                item.api_source !== 'NOT_FOUND' &&
                item.api_source !== 'LOOKUP_ERROR' &&
                !item.api_source.includes('ERROR'))
            .map(item => item.tracking_status)
        )];
        const sortedStatuses = uniqueStatuses.sort((a, b) => {
            if (a.includes('Delivered')) return 1;
            if (b.includes('Delivered')) return -1;
            if (a.includes('Exception')) return -1;
            if (b.includes('Exception')) return 1;
            return a.localeCompare(b);
        });
        setTrackingStatusFilters(['all', ...sortedStatuses]);
        setTrackingLastUpdated(new Date().toLocaleString());
    };

    // Быстрая загрузка из БД — без запросов к API (при открытии вкладки)
    const loadTrackingFromDB = async () => {
        try {
            setTrackingLoading(true);
            const packagesWithTracking = packages.filter(pkg => pkg.tracking_number);
            if (packagesWithTracking.length === 0) {
                setTrackingData([]);
                setTrackingStatusFilters([]);
                setTrackingLastUpdated(new Date().toLocaleString());
                return;
            }
            const response = await api.get(`/api/tracking/from-db`, { params: { date: shipDate } });
            if (response.data.success) {
                const mergedData = mergeTrackingResults(packagesWithTracking, response.data.results);
                applyTrackingResults(mergedData);
                const deliveredCount = mergedData.filter(i => i.is_delivered).length;
                const noDataCount = mergedData.filter(i => i.api_source === 'NO_DATA').length;
                const dbCacheCount = mergedData.filter(i => i.api_source === 'DB_CACHE').length;
                setMessage(`Loaded from DB: ${deliveredCount} delivered, ${dbCacheCount} with status, ${noDataCount} no status yet. Click Refresh to update via API.`);
            }
        } catch (error) {
            console.error('Error loading tracking from DB:', error);
            setMessage(`Error loading tracking: ${error.message}`);
        } finally {
            setTrackingLoading(false);
        }
    };

    // Обновление через API (ручной рефреш)
    const fetchTrackingData = async () => {
        try {
            setTrackingLoading(true);

            const packagesWithTracking = packages.filter(pkg => pkg.tracking_number);

            if (packagesWithTracking.length === 0) {
                setTrackingData([]);
                setTrackingStatusFilters([]);
                setTrackingLastUpdated(new Date().toLocaleString());
                setMessage('No packages with tracking numbers to track');
                return;
            }

            const response = await api.post(`/api/tracking/batch-by-date`, {
                date: shipDate,
                limit: 200
            });
            
            if (response.data.success && response.data.results) {
                // Объединяем данные пакетов с данными трекинга
                const mergedData = packagesWithTracking.map(pkg => {
                    const trackingInfo = response.data.results.find(
                        t => t.tracking_number === pkg.tracking_number
                    );
                    
                    if (trackingInfo) {
                        // Проверяем тип ошибки по перевозчику
                        const isUPSError = trackingInfo.api_source === 'UPS_API_ERROR';
                        const isUSPSError = trackingInfo.api_source === 'USPS_API_UNAVAILABLE' ||
                            trackingInfo.api_source === 'USPS_API_NOT_CONFIGURED' ||
                            trackingInfo.api_source === 'USPS_API_ERROR';
                        if (isUPSError || isUSPSError) {
                            return {
                                id: pkg.id,
                                order_number: pkg.order_number,
                                tracking_number: pkg.tracking_number,
                                service: pkg.service,
                                ship_date: pkg.ship_date,
                                order_date: pkg.order_date,
                                scanned_date: pkg.scanned_at,
                                last_update: pkg.updated_at,
                                tracking_status: isUPSError ? 'UPS API Error' : 'USPS API Unavailable',
                                status_description: trackingInfo.status_description ||
                                                trackingInfo.error ||
                                                (isUPSError ? 'UPS tracking unavailable' : 'USPS tracking not configured'),
                                movement: 'not_moving',
                                days_since_last_update: 0,
                                estimated_delivery: null,
                                carrier: isUPSError ? 'UPS' : 'USPS',
                                is_delivered: false,
                                exception_code: null,
                                exception_description: trackingInfo.error || (isUPSError ? 'UPS API not available' : 'USPS API not available'),
                                api_source: trackingInfo.api_source || 'ERROR',
                                warehouse_status: pkg.status || 'Not Scanned'
                            };
                        }
                        
                        // Нормальные данные трекинга
                        return {
                            id: pkg.id,
                            order_number: pkg.order_number,
                            tracking_number: pkg.tracking_number,
                            service: pkg.service,
                            ship_date: pkg.ship_date,
                            order_date: pkg.order_date,
                            scanned_date: pkg.scanned_at,
                            last_update: trackingInfo.last_update,
                            tracking_status: trackingInfo.tracking_status,
                            status_description: trackingInfo.status_description,
                            movement: trackingInfo.movement,
                            days_since_last_update: trackingInfo.days_stuck || 0,
                            estimated_delivery: trackingInfo.estimated_delivery,
                            carrier: trackingInfo.carrier,
                            is_delivered: trackingInfo.is_delivered,
                            exception_code: trackingInfo.exception_code,
                            exception_description: trackingInfo.exception_description,
                            api_source: trackingInfo.api_source,
                            warehouse_status: pkg.status || 'Not Scanned' // Добавляем статус склада
                        };
                    }
                    
                    // Если данных трекинга нет — пакет уже Delivered в БД (исключён из API запроса)
                    const savedStatus = pkg.tracking_status;
                    const isDelivered = savedStatus === 'Delivered';
                    return {
                        id: pkg.id,
                        order_number: pkg.order_number,
                        tracking_number: pkg.tracking_number,
                        service: pkg.service,
                        ship_date: pkg.ship_date,
                        order_date: pkg.order_date,
                        scanned_date: pkg.scanned_at,
                        last_update: pkg.updated_at,
                        tracking_status: savedStatus || 'Pending',
                        status_description: isDelivered ? 'Delivered' : 'Awaiting tracking information',
                        movement: isDelivered ? 'delivered' : 'not_moving',
                        days_since_last_update: 0,
                        estimated_delivery: null,
                        carrier: 'USPS',
                        is_delivered: isDelivered,
                        exception_code: null,
                        exception_description: null,
                        api_source: isDelivered ? 'DB_CACHE' : 'NO_DATA',
                        warehouse_status: pkg.status || 'Not Scanned'
                    };
                });
                
                setTrackingData(mergedData);
                
                // Собираем уникальные статусы из данных
                const uniqueStatuses = [...new Set(mergedData
                    .filter(item => item.tracking_status && !item.tracking_status.includes('API') && item.api_source && !item.api_source.includes('ERROR'))
                    .map(item => item.tracking_status)
                )];

                // Сортируем статусы для удобства (доставленные в конце, исключения в начале)
                const sortedStatuses = uniqueStatuses.sort((a, b) => {
                    if (a.includes('Delivered')) return 1;
                    if (b.includes('Delivered')) return -1;
                    if (a.includes('Exception')) return -1;
                    if (b.includes('Exception')) return 1;
                    return a.localeCompare(b);
                });

                setTrackingStatusFilters(['all', ...sortedStatuses]);

                // Обновляем статистику
                const notMovingCount = mergedData.filter(item =>
                    item.movement === 'not_moving' &&
                    item.api_source !== 'NO_DATA' &&
                    item.tracking_status && !item.tracking_status.includes('API') &&
                    item.api_source && !item.api_source.includes('ERROR')
                ).length;
                const inTransitCount = mergedData.filter(item =>
                    item.movement === 'in_transit' &&
                    item.api_source !== 'NO_DATA' &&
                    item.tracking_status && !item.tracking_status.includes('API') &&
                    item.api_source && !item.api_source.includes('ERROR')
                ).length;
                const deliveredCount = mergedData.filter(item =>
                    item.movement === 'delivered' &&
                    item.api_source !== 'NO_DATA' &&
                    item.tracking_status && !item.tracking_status.includes('API') &&
                    item.api_source && !item.api_source.includes('ERROR')
                ).length;
                const noDataCount = mergedData.filter(item => item.api_source === 'NO_DATA').length;
                const unavailableCount = mergedData.filter(item =>
                    item.api_source !== 'NO_DATA' &&
                    ((item.tracking_status && item.tracking_status.includes('API')) ||
                    (item.api_source && item.api_source.includes('ERROR')))
                ).length;
                
                // Добавляем статистику по статусу склада
                const scannedCount = mergedData.filter(item => 
                    item.warehouse_status === 'Scanned'
                ).length;
                const notScannedCount = mergedData.filter(item => 
                    item.warehouse_status === 'Not Scanned'
                ).length;
                
                const dbSaved = response.data.db_saved ?? '?';
                setMessage(`Refresh done: ${notMovingCount} not moving, ${inTransitCount} in transit, ${deliveredCount} delivered, ${noDataCount} no API data, ${unavailableCount} errors. DB saved: ${dbSaved}. Warehouse: ${scannedCount}/${scannedCount + notScannedCount} scanned.`);
                
            } else {
                throw new Error('Invalid response from tracking API');
            }
            
            setTrackingLastUpdated(new Date().toLocaleString());
            
        } catch (error) {
            console.error('Error fetching tracking data:', error);
            
            // Вместо мок данных показываем только сканированные пакеты с информацией об ошибке
            const packagesWithTracking = packages.filter(pkg => pkg.tracking_number);
            const trackingOnly = packagesWithTracking.map(pkg => ({
                id: pkg.id,
                order_number: pkg.order_number,
                tracking_number: pkg.tracking_number,
                service: pkg.service,
                ship_date: pkg.ship_date,
                order_date: pkg.order_date,
                scanned_date: pkg.scanned_at,
                last_update: pkg.updated_at,
                tracking_status: 'API Error',
                status_description: `Tracking API unavailable: ${error.message}`,
                movement: 'not_moving',
                days_since_last_update: 0,
                estimated_delivery: null,
                carrier: 'Unknown',
                is_delivered: false,
                exception_code: 'API_ERROR',
                exception_description: error.message,
                api_source: 'API_ERROR',
                warehouse_status: pkg.status || 'Not Scanned' // Добавляем статус склада
            }));
            
            setTrackingData(trackingOnly);
            setTrackingStatusFilters(['all', 'API Error']);
            
            setMessage(`Tracking API error: ${error.message}`);
            setTrackingLastUpdated(new Date().toLocaleString() + ' (error)');
        } finally {
            setTrackingLoading(false);
        }
    };

    // Обновите функцию фильтрации:
    const getFilteredTrackingData = () => {
        let filtered = trackingData;

        // Фильтр по статусу трекинга
        if (selectedStatusFilter !== 'all') {
            filtered = filtered.filter(item => item.tracking_status === selectedStatusFilter);
        }

        // Фильтр по поисковому запросу
        if (trackingSearchQuery.trim()) {
            const q = trackingSearchQuery.trim().toLowerCase();
            filtered = filtered.filter(item =>
                (item.order_number || '').toLowerCase().includes(q) ||
                (item.tracking_number || '').toLowerCase().includes(q)
            );
        }

        // Фильтр по статусу склада
        if (filterTrackingWarehouseStatus !== 'All') {
            filtered = filtered.filter(item => item.warehouse_status === filterTrackingWarehouseStatus);
        }

        // Фильтр по перевозчику
        if (filterTrackingCarrier !== 'All') {
            if (filterTrackingCarrier === 'UPS') {
                filtered = filtered.filter(item =>
                    (item.carrier || '').toUpperCase().includes('UPS')
                );
            } else if (filterTrackingCarrier === 'USPS') {
                filtered = filtered.filter(item =>
                    (item.carrier || '').toUpperCase().includes('USPS')
                );
            } else if (filterTrackingCarrier === 'Other') {
                filtered = filtered.filter(item =>
                    !(item.carrier || '').toUpperCase().includes('UPS') &&
                    !(item.carrier || '').toUpperCase().includes('USPS')
                );
            }
        }

        return filtered;
    };

    // Загружаем застрявшие посылки
    const fetchStuckPackages = async () => {
        try {
            setStuckLoading(true);
            
            // Загружаем статистику
            const statsResponse = await api.get(`/api/packages/stuck/stats`, {
                params: { days: stuckDaysFilter }
            });
            
            if (statsResponse.data.success) {
                setStuckStats(statsResponse.data.stats);
            }
            
            // Загружаем детальные данные
            const response = await api.get(`/api/packages/stuck`, {
                params: { 
                    days: stuckDaysFilter,
                    limit: 500,
                    dateFrom: stuckDateFrom || undefined,
                    dateTo: stuckDateTo || undefined
                }
            });
            
            if (response.data.success) {
                setStuckPackages(response.data.stuck_packages || []);
                setMessage(`Found ${response.data.count} stuck packages out of ${response.data.total_checked} checked`);
            } else {
                throw new Error(response.data.error || 'Failed to load stuck packages');
            }
            
        } catch (error) {
            console.error('Error fetching stuck packages:', error);
            setMessage(`Error loading stuck packages: ${error.message}`);
            setStuckPackages([]);
        } finally {
            setStuckLoading(false);
        }
    };

    // Фильтрация застрявших посылок
    const getFilteredStuckPackages = () => {
        let filtered = stuckPackages;

        // Фильтр по поисковому запросу
        if (stuckSearchQuery.trim()) {
            const q = stuckSearchQuery.trim().toLowerCase();
            filtered = filtered.filter(item =>
                (item.order_number || '').toLowerCase().includes(q) ||
                (item.tracking_number || '').toLowerCase().includes(q)
            );
        }

        // Фильтр по перевозчику
        if (stuckCarrierFilter !== 'All') {
            if (stuckCarrierFilter === 'UPS') {
                filtered = filtered.filter(item =>
                    (item.carrier || '').toUpperCase().includes('UPS')
                );
            } else if (stuckCarrierFilter === 'USPS') {
                filtered = filtered.filter(item =>
                    (item.carrier || '').toUpperCase().includes('USPS')
                );
            } else if (stuckCarrierFilter === 'Other') {
                filtered = filtered.filter(item =>
                    !(item.carrier || '').toUpperCase().includes('UPS') &&
                    !(item.carrier || '').toUpperCase().includes('USPS')
                );
            }
        }

        // Фильтр по статусу склада
        if (stuckWarehouseFilter !== 'All') {
            filtered = filtered.filter(item => 
                item.warehouse_status === stuckWarehouseFilter
            );
        }

        return filtered;
    };

    // При открытии вкладки — читаем только из БД (без API)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (activeTab === 'tracking' && packages.length > 0) {
            loadTrackingFromDB();
        }
    }, [activeTab, packages]);

    useEffect(() => {
        if (activeTab === 'ssstock') {
            fetchSsStock();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    const formatScanTimeEST = (dateTimeString) => {
        if (!dateTimeString) return '—';
        
        try {
            const date = new Date(dateTimeString);
            
            return date.toLocaleString('en-US', {
                timeZone: 'America/New_York',
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });
        } catch (error) {
            console.error('Error formatting scan time:', error);
            return '—';
        }
    };

// const formatShipDateEST = (dateString) => {
//     if (!dateString) return '—';
    
//     try {
//         // Если дата уже в формате Date
//         if (dateString instanceof Date) {
//             return dateString.toLocaleDateString('en-US', {
//                 timeZone: 'America/New_York',
//                 month: 'short',
//                 day: 'numeric',
//                 year: 'numeric'
//             });
//         }
        
//         // Пробуем разные форматы
//         let date;
//         if (dateString.includes('-')) {
//             // Формат YYYY-MM-DD
//             const [year, month, day] = dateString.split('-');
//             date = new Date(year, month - 1, day);
//         } else if (dateString.includes('/')) {
//             // Формат MM/DD/YYYY
//             const [month, day, year] = dateString.split('/');
//             date = new Date(year, month - 1, day);
//         } else {
//             // Пробуем стандартный парсинг
//             date = new Date(dateString);
//         }
        
//         if (isNaN(date.getTime())) {
//             return '—';
//         }
        
//         const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
//                            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        
//         return `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
//     } catch (error) {
//         console.error('Error formatting date:', error, dateString);
//         return '—';
//     }
// };


    const formatShipDateEST = (dateString) => {
        if (!dateString) return '—';
        
        try {
            let date;
            if (typeof dateString === 'string') {
                // Преобразуем "2026-01-16 06:55:02" в ISO "2026-01-16T06:55:02"
                const isoString = dateString.replace(' ', 'T');
                date = new Date(isoString);
            } else if (dateString instanceof Date) {
                date = dateString;
            } else {
                date = new Date(dateString);
            }
            
            if (isNaN(date.getTime())) return '—';
            
            return date.toLocaleDateString('en-US', {
                timeZone: 'America/New_York',
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        } catch (error) {
            console.error('Error formatting date:', error, dateString);
            return '—';
        }
    };

    // Format date-only values (YYYY-MM-DD) without timezone shifting
    const formatDateOnly = (dateString) => {
        if (!dateString) return '—';
        // If it's already YYYY-MM-DD, format it directly
        if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            const [year, month, day] = dateString.split('-');
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            return `${monthNames[parseInt(month) - 1]} ${parseInt(day)}, ${year}`;
        }
        // Fallback to the original (datetime) formatter if the format is unexpected
        return formatShipDateEST(dateString);
    };
    const refreshAssemblyStatuses = (pkgList) => {
        const list = pkgList || packages;
        if (!list.length) return;
        const orderNumbers = [...new Set(list.map(p => p.order_number).filter(Boolean))];
        api.post(`/api/assembly/statuses`, { order_numbers: orderNumbers })
            .then(res => {
                setAssemblyStatuses(res.data.statuses || {});
                setAmazonOrders(new Set(res.data.amazon || []));
            })
            .catch(() => {});
    };

    const fetchPackages = async () => {
        try {
            setLoading(true);
            const response = await api.get(`/api/packages`, {
                params: { date: shipDate }
            });
            
            let pkgs = [];
            if (response.data.packages && response.data.stats) {
                pkgs = response.data.packages;
                setPackages(pkgs);
                setStats(response.data.stats);
            } else if (Array.isArray(response.data)) {
                pkgs = response.data;
                setPackages(pkgs);
                setStats({ totalScanningMinutes: 0, avgPerPackageMinutes: 0 });
            }
            // Подгружаем статусы сборки для всех заказов
            if (pkgs.length > 0) {
                const orderNumbers = [...new Set(pkgs.map(p => p.order_number).filter(Boolean))];
                api.post(`/api/assembly/statuses`, { order_numbers: orderNumbers })
                    .then(res => {
                        setAssemblyStatuses(res.data.statuses || {});
                        setAmazonOrders(new Set(res.data.amazon || []));
                    })
                    .catch(() => {});
            }
        } catch (error) {
            console.error('Error fetching packages:', error);
            setMessage('Error loading packages');
        } finally {
            setLoading(false);
            // Включаем автофокус только если пользователь не взаимодействовал с другими элементами
            if (shouldRefocusTextarea) {
                setTimeout(() => {
                    if (textareaRef.current && activeTab === 'scanner') {
                        textareaRef.current.focus();
                    }
                }, 0);
            }
        }
    };

    const handleCheck = async () => {
        try {
            setLoading(true);
            setMessage('');
            
            const barcodeArray = barcodes
                .split('\n')
                .map(b => b.trim())
                .filter(b => b.length > 0);

            if (barcodeArray.length === 0) {
                setMessage('Please enter at least one barcode');
                setTimeout(() => {
                    if (textareaRef.current) {
                        textareaRef.current.focus();
                    }
                }, 0);
                return;
            }

            const trackingNumbers = barcodeArray.map(barcode => {
                const tracking = extractTrackingFromBarcode(barcode);
                console.log(`Barcode: ${barcode}, Extracted tracking: ${tracking}`);
                return tracking;
            }).filter(tracking => tracking !== null);

            if (trackingNumbers.length === 0) {
                setMessage('No valid tracking numbers found in barcodes');
                setTimeout(() => {
                    if (textareaRef.current) {
                        textareaRef.current.focus();
                    }
                }, 0);
                return;
            }

            const response = await api.post(`/api/check-barcodes`, {
                barcodes: trackingNumbers,
                shipDate: shipDate
            });

            setMessage(response.data.message);
            if (Array.isArray(response.data.packages)) {
                setPackages(response.data.packages);
            }

            if (response.data.updatedCount === 0) {
                fetchPackages();
            }

            // Открываем попап сборки для только что отсканированного заказа
            if (response.data.updatedCount > 0 && Array.isArray(response.data.packages)) {
                const scannedTracking = trackingNumbers[0];
                const scannedPkg = response.data.packages.find(p => p.tracking_number === scannedTracking);
                if (scannedPkg?.order_number) {
                    setOrderPopup({
                        orderNumber: scannedPkg.order_number,
                        trackingNumber: scannedPkg.tracking_number || null,
                        rows: response.data.packages.map(p => ({ order_number: p.order_number, tracking_number: p.tracking_number })),
                        dates: Object.fromEntries(response.data.packages.map(p => [p.order_number + '|' + p.tracking_number, p.order_date]))
                    });
                }
            }

            setBarcodes('');
            
            // Всегда возвращаем фокус после сканирования (Enter)
            setTimeout(() => {
                if (textareaRef.current) {
                    textareaRef.current.focus();
                }
            }, 0);
            
        } catch (error) {
            console.error('Error checking barcodes:', error);
            setMessage(error.response?.data?.error || 'Error checking barcodes');
            
            setTimeout(() => {
                if (textareaRef.current) {
                    textareaRef.current.focus();
                }
            }, 0);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleCheck();
        }
    };

    const handleDateChange = (e) => {
        setShipDate(e.target.value);
        // При изменении даты не возвращаем фокус автоматически
        // Пользователь может хотеть использовать другие элементы
    };

    const handleFileUpload = async (e) => {
        const files = e.target.files;
        if (!files?.length) return;

        setUploading(true);
        setMessage('');
        setUploadResults([]);

        const formData = new FormData();
        for (const file of files) {
            formData.append('csvFiles', file);
        }
        formData.append('shipDate', shipDate);

        try {
            const res = await api.post(`/api/upload-packages`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setUploadResults(res.data.results || []);
            setMessage(res.data.message);
            const uploadedPackages = res.data.packages || packages;
            setPackages(uploadedPackages);

            // Запускаем подгрузку составов заказов из Veeqo
            syncVeeqoItems(uploadedPackages);

        } catch (err) {
            console.error(err);
            setMessage(err.response?.data?.error || 'Error uploading orders');
        } finally {
            setUploading(false);
            if (fileInputRef.current) fileInputRef.current.value = '';
            setTimeout(() => {
                if (textareaRef.current && activeTab === 'scanner') {
                    textareaRef.current.focus();
                }
            }, 0);
        }
    };

    const handleResend = async (pkg) => {
        try {
            await api.put(`/api/packages/${pkg.id}/resend`);
            const today = new Date().toISOString().split('T')[0];
            setPackages(prev => prev.map(p =>
                p.id === pkg.id ? { ...p, status: 'Not Scanned', is_resend: 1, scanned_at: null, ship_date: today } : p
            ));
            setAssemblyStatuses(prev => ({ ...prev, [pkg.order_number]: 'pending' }));
        } catch (err) {
            alert(err.response?.data?.error || 'Failed to mark for resend');
        }
    };

    const syncVeeqoItems = async (pkgList) => {
        const toSync = (pkgList || []).filter(p => p.order_number);
        if (toSync.length === 0) return;

        try {
            const res = await api.post(`/api/veeqo/sync-batch`, {
                orders: toSync.map(p => ({ order_number: p.order_number }))
            });
            if (res.data.success && res.data.jobId) {
                localStorage.setItem('veeqoSyncJobId', res.data.jobId);
                startPollingJob(res.data.jobId, res.data.total);
            }
        } catch (_) { /* не критично */ }
    };

    const startPollingJob = (jobId, total) => {
        setVeeqoSyncing(true);
        setVeeqoSyncTotal(total);
        setVeeqoSyncProgress(0);
        setVeeqoSyncFound(0);

        const interval = setInterval(async () => {
            try {
                const res = await api.get(`/api/veeqo/sync-status/${jobId}`);
                if (res.data.success) {
                    setVeeqoSyncProgress(res.data.done);
                    setVeeqoSyncFound(res.data.found);
                    setVeeqoSyncTotal(res.data.total);
                    if (res.data.status === 'done') {
                        clearInterval(interval);
                        setVeeqoSyncing(false);
                        localStorage.removeItem('veeqoSyncJobId');
                    }
                } else {
                    // Job истёк или не найден
                    clearInterval(interval);
                    setVeeqoSyncing(false);
                    localStorage.removeItem('veeqoSyncJobId');
                }
            } catch (_) { /* игнорируем сетевые ошибки */ }
        }, 2000);
    };

    const extractTrackingFromBarcode = (barcode) => {
        if (!barcode) return null;

        const clean = barcode.trim().replace(/[^A-Za-z0-9]/g, '');

        if (clean.length < 10) return null;

        if (clean.startsWith('420')) {
            // 420 + ZIP5 (Shopify/Amazon) или 420 + ZIP+4 (Stamps.com), затем 20–22-значный трек
            const m = clean.match(/^420\d{5}(?:\d{4})?(9[2-5]\d{18,20})$/);
            return m ? m[1] : clean.substring(8);
        }

        if (clean.startsWith('1Z') && clean.length === 18) {
            return clean.toUpperCase();
        }

        if (/^(92|93|94|95)\d{18,20}$/.test(clean)) {
            return clean;
        }

        if (/^94\d{20}$/.test(clean) || /^92\d{20}$/.test(clean)) {
            return clean;
        }

        // USPS First Class International (S10: 2 буквы + 8 цифр + чек + 2 буквы страны)
        if (/^[A-Z]{2}\d{9}[A-Z]{2}$/.test(clean)) {
            return clean;
        }

        // Международный трекинг внутри длинного баркода
        const intlMatch = clean.match(/[A-Z]{2}\d{9}[A-Z]{2}/);
        if (intlMatch) {
            return intlMatch[0];
        }

        if (/^\d{20,22}$/.test(clean)) {
            return clean;
        }

        return null;
    };

    const getFilteredPackages = () => {
        let filtered = packages;

        if (searchQuery.trim()) {
            const q = searchQuery.trim().toLowerCase();
            filtered = filtered.filter(pkg =>
                (pkg.order_number || '').toLowerCase().includes(q) ||
                (pkg.tracking_number || '').toLowerCase().includes(q)
            );
        }

        if (filterStatus !== 'All') {
            filtered = filtered.filter(pkg => pkg.status === filterStatus);
        }

        if (filterService !== 'All') {
            if (filterService === 'UPS') {
                filtered = filtered.filter(pkg =>
                    (pkg.service || '').toUpperCase().includes('UPS')
                );
            } else if (filterService === 'USPS') {
                filtered = filtered.filter(pkg =>
                    (pkg.service || '').toUpperCase().includes('USPS') ||
                    (pkg.service || '').toUpperCase().includes('PRIORITY') ||
                    (pkg.service || '').toUpperCase().includes('FIRST-CLASS')
                );
            } else if (filterService === 'Other') {
                filtered = filtered.filter(pkg =>
                    !(pkg.service || '').toUpperCase().includes('UPS') &&
                    !(pkg.service || '').toUpperCase().includes('USPS') &&
                    !(pkg.service || '').toUpperCase().includes('PRIORITY') &&
                    !(pkg.service || '').toUpperCase().includes('FIRST-CLASS')
                );
            }
        }

        if (sortField) {
            filtered = [...filtered].sort((a, b) => {
                const aVal = a[sortField] ? new Date(a[sortField]).getTime() : 0;
                const bVal = b[sortField] ? new Date(b[sortField]).getTime() : 0;
                return sortDir === 'asc' ? aVal - bVal : bVal - aVal;
            });
        }

        return filtered;
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDir(d => d === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDir('asc');
        }
    };

    const SortIcon = ({ field }) => {
        if (sortField !== field) return <span className="ps-sort-icon">↕</span>;
        return <span className="ps-sort-icon ps-sort-icon--active">{sortDir === 'asc' ? '↑' : '↓'}</span>;
    };

    const handleCheckButtonClick = () => {
        handleCheck();
    };

    const handleClearButtonClick = () => {
        setBarcodes('');
        setMessage('');
        // При клике на Clear возвращаем фокус
        setTimeout(() => {
            if (textareaRef.current) {
                textareaRef.current.focus();
            }
        }, 0);
    };

    const handleTodayButtonClick = () => {
        setShipDate(new Date().toISOString().split('T')[0]);
        setSelectedStatusFilter('all'); // Сброс фильтра при смене даты
        // Сброс фильтров для второй вкладки
        setTrackingSearchQuery('');
        setFilterTrackingWarehouseStatus('All');
        setFilterTrackingCarrier('All');
        setTimeout(() => {
            if (textareaRef.current && activeTab === 'scanner') {
                textareaRef.current.focus();
            }
        }, 0);
    };

    const handleRefreshTracking = () => {
        setSelectedStatusFilter('all');
        // Сброс фильтров для второй вкладки
        setTrackingSearchQuery('');
        setFilterTrackingWarehouseStatus('All');
        setFilterTrackingCarrier('All');
        fetchTrackingData();
    };

    // Функция для определения класса статуса трекинга
    const getTrackingStatusClass = (status) => {
        if (!status) return 'ps-badge--muted';
        if (status.includes('Delivered') || status.includes('DELIVERED')) return 'ps-badge--green';
        if (status === 'In Transit') return 'ps-badge--cyan';
        if (status === 'Out for Delivery') return 'ps-badge--orange';
        if (status === 'Label Created' || status === 'Pending') return 'ps-badge--muted';
        if (status.includes('Exception') || status.includes('Error') || status.includes('ERROR')) return 'ps-badge--red';
        if (status.includes('API')) return 'ps-badge--muted';
        return 'ps-badge--muted';
    };

    // Функция для определения цвета статуса трекинга
    const getTrackingStatusColor = (status) => {
        if (!status) return '#6c757d';
        switch (status) {
            case 'Delivered': return '#28a745';
            case 'In Transit': return '#17a2b8';
            case 'Out for Delivery': return '#fd7e14';
            case 'Label Created': return '#6c757d';
            case 'Exception': return '#dc3545';
            case 'Pending': return '#ffc107';
            case 'USPS API Unavailable': return '#9c27b0';
            case 'UPS API Error': return '#9c27b0';
            case 'API Access Required': return '#9c27b0';
            case 'API Error': return '#f44336';
            default:
                if (status.includes('Delivered') || status.includes('DELIVERED')) return '#28a745';
                if (status.includes('Exception') || status.includes('EXCEPTION')) return '#dc3545';
                return '#6c757d';
        }
    };

    // Функция для определения иконки статуса
    const getTrackingStatusIcon = (status) => {
        if (!status) return '';
        switch (status) {
            case 'Delivered': return '';
            case 'In Transit': return '';
            case 'Out for Delivery': return '';
            case 'Label Created': return '';
            case 'Exception': return '';
            case 'Pending': return '';
            case 'USPS API Unavailable': return '';
            case 'UPS API Error': return '';
            case 'API Access Required': return '';
            case 'API Error': return '';
            default:
                if (status.includes('Delivered') || status.includes('DELIVERED')) return '';
                if (status.includes('Exception') || status.includes('EXCEPTION')) return '';
                return '';
        }
    };

    // Обработчики для элементов, которые не должны возвращать фокус
    const handleSearchFocus = () => {
        setShouldRefocusTextarea(false);
    };

    const handleSearchBlur = () => {
        setShouldRefocusTextarea(true);
    };

    const handleFilterFocus = () => {
        setShouldRefocusTextarea(false);
    };

    const handleFilterBlur = () => {
        setShouldRefocusTextarea(true);
    };

    // ─── SS Stock ───────────────────────────────────────────────────────────────

    const fetchSsStock = async () => {
        try {
            setSsStockLoading(true);
            const res = await api.get(`/api/ss-stock`);
            if (res.data.success) setSsStockData(res.data.items || []);
        } catch (err) {
            console.error('Error fetching SS stock:', err);
        } finally {
            setSsStockLoading(false);
        }
    };

    const parseSsBoxLine = (line, index) => {
        try {
            // Name is greedy (may contain commas), SKU is the last comma-free part before BOX#
            const match = line.match(
                /^(?:(\d{4}\/\d{2}\/\d{2}) (\d{2}:\d{2}:\d{2}) )?(.+), ([^,]+), BOX#(.+?)\/(\d+)(?: (\d{4}\/\d{2}\/\d{2}) (\d{2}:\d{2}:\d{2}))?$/
            );
            if (!match) throw new Error(`Row ${index + 1}: Invalid format.`);
            let [, , , prefixSetName, sku, boxNumber, quantity] = match;
            const parts = prefixSetName.split('-');
            const hasPrefix = /^[A-Z]+$/.test(parts[0]);
            const setName = hasPrefix ? parts.slice(1).join('-').trim() : prefixSetName.trim();
            return { sku: sku.trim(), boxNumber: boxNumber.trim(), quantity: parseInt(quantity.trim(), 10), setName };
        } catch (_) {
            return null;
        }
    };

    const handleAddBoxesToSsStock = async () => {
        setSsStockSaveMsg('');
        const lines = ssStockBoxText.trim().split('\n');
        const parsed = lines.map((line, i) => parseSsBoxLine(line, i)).filter(Boolean);

        const unique = [];
        const seen = new Set();
        parsed.forEach(e => {
            const key = `${e.sku}-${e.boxNumber}`;
            if (!seen.has(key)) { seen.add(key); unique.push(e); }
        });

        if (unique.length === 0) {
            setSsStockSaveMsg('No valid boxes recognized. Check format: Name, SKU, BOX#number/qty');
            return;
        }

        try {
            setSsStockSaving(true);
            const res = await api.post(`/api/ss-stock/add-boxes`, { data: unique });
            if (res.data.success) {
                const notInStock = (res.data.results || []).filter(r => r.status === 'box_not_in_stock').map(r => r.sku).join(', ');
                const skuNotFound = (res.data.results || []).filter(r => r.status === 'sku_not_found').map(r => r.sku).join(', ');
                let msg = `Added ${res.data.added} box(es) to SS Stock.`;
                if (notInStock) msg += ` Box not in main stock: ${notInStock}.`;
                if (skuNotFound) msg += ` SKU not found: ${skuNotFound}.`;
                setSsStockSaveMsg(msg);
                setSsStockBoxText('');
                fetchSsStock();
            }
        } catch (err) {
            setSsStockSaveMsg(err.response?.data?.error || 'Error saving to SS Stock');
        } finally {
            setSsStockSaving(false);
        }
    };

    const getSsStockFiltered = () => {
        let items = ssStockData;
        if (ssStockBrandFilter !== 'All') {
            items = items.filter(i => i.brand_name === ssStockBrandFilter);
        }
        if (ssStockSearch.trim()) {
            const q = ssStockSearch.trim().toLowerCase();
            items = items.filter(i =>
                (i.sku || '').toLowerCase().includes(q) ||
                (i.gtin || '').toLowerCase().includes(q) ||
                (i.product_name || '').toLowerCase().includes(q)
            );
        }
        return items;
    };

    const ssStockBrands = ['All', ...[...new Set(ssStockData.map(i => i.brand_name).filter(Boolean))].sort()];

    const startEditQty = (item) => {
        setEditingId(item.sku);
        setEditingQty(String(item.quantity));
    };

    const cancelEditQty = () => {
        setEditingId(null);
        setEditingQty('');
    };

    const putQty = async (item, newQty, extra = {}) => {
        await api.put(`/api/ss-stock/sku/${encodeURIComponent(item.sku)}/quantity`, {
            quantity: newQty,
            gtin: item.gtin,
            brand_id: item.brand_id,
            brand_name: item.brand_name,
            product_name: item.product_name,
            product_type: item.product_type,
            ...extra,
        });
        setSsStockData(prev => prev.map(i => i.sku === item.sku ? { ...i, quantity: newQty } : i));
    };

    const saveEditQty = async (item) => {
        const newQty = parseInt(editingQty, 10);
        if (isNaN(newQty) || newQty < 0) { cancelEditQty(); return; }
        setEditingId(null);
        setEditingQty('');
        const diff = newQty - item.quantity;
        // Увеличение = сборка из материалов: подтверждение списания
        // (для wildmicr/fertilizer — с запросом номера мешка сырья;
        // галочка "old stock" позволяет добавить без списания)
        if (diff > 0 && ['set', 'individual', 'wildmicr', 'fertilizer', 'readyproduct'].includes(item.product_type)) {
            setBagPopup({ item, newQty, diff, bag: '', info: null, error: '', busy: false });
            return;
        }
        try {
            await putQty(item, newQty);
        } catch (err) {
            console.error('Error updating qty:', err);
        }
    };

    const checkBagInfo = async () => {
        const bag = bagPopup.bag.trim();
        if (!bag) return;
        setBagPopup(p => ({ ...p, busy: true, error: '', info: null }));
        try {
            const res = await api.get('/api/ss-stock/bag-info', { params: { sku: bagPopup.item.sku, bag } });
            if (res.data.success) {
                setBagPopup(p => ({ ...p, busy: false, info: res.data }));
            } else {
                setBagPopup(p => ({
                    ...p, busy: false,
                    error: res.data.reason === 'bag_not_found'
                        ? `Bag ${bag} not found in stock for this material`
                        : 'This product type is not supported'
                }));
            }
        } catch (err) {
            setBagPopup(p => ({ ...p, busy: false, error: err.response?.data?.error || 'Error checking bag' }));
        }
    };

    const confirmBagPopup = async () => {
        setBagPopup(p => ({ ...p, busy: true, error: '' }));
        try {
            const extra = {};
            if (bagPopup.skipOld) extra.skip_materials = true;
            else if (['wildmicr', 'fertilizer'].includes(bagPopup.item.product_type)) extra.bag_number = bagPopup.bag.trim();
            await putQty(bagPopup.item, bagPopup.newQty, extra);
            setBagPopup(null);
        } catch (err) {
            setBagPopup(p => ({ ...p, busy: false, error: err.response?.data?.error || 'Error saving' }));
        }
    };

    const openHistory = async (sku, productName) => {
        setHistoryPopup({ sku, productName: productName || sku, items: [] });
        setHistoryLoading(true);
        try {
            const res = await api.get(`/api/ss-stock/history/${encodeURIComponent(sku)}`);
            if (res.data.success) setHistoryPopup({ sku, productName: productName || sku, items: res.data.items || [] });
        } catch (err) {
            console.error('Error loading history:', err);
        } finally {
            setHistoryLoading(false);
        }
    };

    // ────────────────────────────────────────────────────────────────────────────

    const filteredPackages = getFilteredPackages();
    const filteredTrackingData = getFilteredTrackingData();

    const totalPackages = Array.isArray(packages) ? packages.length : 0;
    const scannedPackages = Array.isArray(packages) 
        ? packages.filter(pkg => pkg?.status === 'Scanned').length 
        : 0;
    const pendingPackages = totalPackages - scannedPackages;

    // Статистика для отслеживания (исключаем пакеты без данных из API)
    const notMovingPackages = trackingData.filter(item =>
        item.movement === 'not_moving' &&
        item.api_source !== 'NO_DATA' &&
        item.tracking_status && !item.tracking_status.includes('API') &&
        item.api_source && !item.api_source.includes('ERROR')
    ).length;
    const inTransitPackages = trackingData.filter(item =>
        item.movement === 'in_transit' &&
        item.api_source !== 'NO_DATA' &&
        item.tracking_status && !item.tracking_status.includes('API') &&
        item.api_source && !item.api_source.includes('ERROR')
    ).length;
    const deliveredPackages = trackingData.filter(item =>
        item.movement === 'delivered' &&
        item.tracking_status && !item.tracking_status.includes('API') &&
        item.api_source && !item.api_source.includes('ERROR')
    ).length;
    const apiErrorPackages = trackingData.filter(item =>
        (item.tracking_status && item.tracking_status.includes('API')) ||
        (item.api_source && item.api_source.includes('ERROR'))
    ).length;
    const warehouseScannedPackages = trackingData.filter(item => 
        item.warehouse_status === 'Scanned'
    ).length;
    const warehouseNotScannedPackages = trackingData.filter(item => 
        item.warehouse_status === 'Not Scanned'
    ).length;


    return (
        <>
            {orderPopup && (
                <OrderItemsPopup
                    orderNumber={orderPopup.orderNumber}
                    trackingNumber={orderPopup.trackingNumber}
                    orderRows={orderPopup.rows}
                    orderDates={orderPopup.dates}
                    onClose={() => { setOrderPopup(null); refreshAssemblyStatuses(); }}
                    onNavigate={navigateOrderPopup}
                    onStatusChange={(status) => setAssemblyStatuses(prev => ({ ...prev, [orderPopup.orderNumber]: status }))}
                    onAmazonShip={(orderNum) => setAmazonOrders(prev => new Set([...prev, orderNum]))}
                    onAllComplete={() => {
                        setOrderPopup(null);
                        refreshAssemblyStatuses();
                        setTimeout(() => {
                            if (textareaRef.current) {
                                textareaRef.current.focus();
                                textareaRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                        }, 50);
                    }}
                />
            )}
            <HeaderLogged />
            <div className="ps-page">
                <div className="ps-inner">
                    <h1 className="ps-page-title">Order Assembly & Shipping</h1>

                    {/* Tabs */}
                    <div className="ps-tabs">
                        <button
                            className={`ps-tab${activeTab === 'scanner' ? ' ps-tab--active' : ''}`}
                            onClick={() => setActiveTab('scanner')}
                        >
                            Scanner Dashboard
                        </button>
                        <button
                            className={`ps-tab${activeTab === 'tracking' ? ' ps-tab--active' : ''}`}
                            onClick={() => setActiveTab('tracking')}
                        >
                            Tracking Monitor
                        </button>
                        <button
                            className={`ps-tab${activeTab === 'stuck' ? ' ps-tab--active' : ''}`}
                            onClick={() => { setActiveTab('stuck'); fetchStuckPackages(); }}
                        >
                            Stuck Packages
                        </button>
                        <button
                            className={`ps-tab${activeTab === 'ssstock' ? ' ps-tab--active' : ''}`}
                            onClick={() => setActiveTab('ssstock')}
                        >
                            SS Stock
                        </button>
                    </div>

                    {/* ═══════════════ SCANNER TAB ═══════════════ */}
                    {activeTab === 'scanner' && (
                        <>
                            <div className="ps-panel">
                                <div className="ps-panel-row">
                                    <span className="ps-date-label">Ship Date:</span>
                                    <input
                                        type="date"
                                        value={shipDate}
                                        onChange={handleDateChange}
                                        className="ps-date-input"
                                        max={new Date().toISOString().split('T')[0]}
                                    />
                                    <button onClick={handleTodayButtonClick} className="ps-btn ps-btn--cyan">
                                        Today
                                    </button>
                                    <button
                                        onClick={() => fileInputRef.current?.click()}
                                        disabled={uploading || loading}
                                        className="ps-btn ps-btn--purple"
                                    >
                                        {uploading ? 'Uploading…' : '↑ Upload CSV'}
                                    </button>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        accept=".csv,.txt"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={handleFileUpload}
                                    />
                                    <button
                                        onClick={() => syncVeeqoItems(packages)}
                                        disabled={veeqoSyncing || uploading || packages.length === 0}
                                        className="ps-btn ps-btn--primary"
                                        title="Fetch order items from Veeqo for orders missing composition"
                                    >
                                        {veeqoSyncing ? '⟳ Syncing…' : '⟳ Sync Items'}
                                    </button>
                                </div>

                                {uploadResults.length > 0 && (
                                    <div className="ps-upload-results">
                                        <strong>Upload Results</strong>
                                        <ul>
                                            {uploadResults.map((r, i) => (
                                                <li key={i}>
                                                    <strong>{r.filename}</strong>:{' '}
                                                    {r.status === 'done'
                                                        ? `Added ${r.inserted}, updated ${r.updated}, skipped ${r.skipped}`
                                                        : `Error — ${r.errorMessages.join('; ')}`}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {(veeqoSyncing || (veeqoSyncTotal > 0 && !veeqoSyncing)) && (
                                    <div className="ps-veeqo-sync">
                                        <div className="ps-veeqo-sync__label">
                                            {veeqoSyncing
                                                ? `Loading order items from Veeqo: ${veeqoSyncProgress} / ${veeqoSyncTotal} (${veeqoSyncFound} found)`
                                                : `Order items loaded: ${veeqoSyncFound} found, ${veeqoSyncTotal - veeqoSyncFound} not in Veeqo`
                                            }
                                        </div>
                                        <div className="ps-veeqo-sync__bar-wrap">
                                            <div
                                                className="ps-veeqo-sync__bar"
                                                style={{ width: `${veeqoSyncTotal > 0 ? Math.round(veeqoSyncProgress / veeqoSyncTotal * 100) : 0}%` }}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="ps-panel-row">
                                    <div className="ps-textarea-wrap" style={{ width: '100%' }}>
                                        <label className="ps-field-label">Scan Barcodes (one per line):</label>
                                        <textarea
                                            ref={textareaRef}
                                            value={barcodes}
                                            onChange={e => setBarcodes(e.target.value)}
                                            onKeyDown={handleKeyPress}
                                            placeholder="Scan barcodes here…"
                                            className="ps-textarea"
                                            disabled={loading}
                                            autoFocus
                                        />
                                        <div className="ps-hint">
                                            USPS: (420)ZIP(93)TRACKING → extracted as 93…22 digits
                                        </div>
                                    </div>
                                </div>

                                <div className="ps-panel-row">
                                    <div className="ps-btn-group">
                                        <button
                                            onClick={handleCheckButtonClick}
                                            disabled={loading || !barcodes.trim()}
                                            className="ps-btn ps-btn--primary"
                                        >
                                            {loading ? 'Processing…' : '✓ Check Barcodes'}
                                        </button>
                                        <button
                                            onClick={handleClearButtonClick}
                                            className="ps-btn ps-btn--ghost"
                                        >
                                            Clear
                                        </button>
                                        <button
                                            onClick={fetchPackages}
                                            className="ps-btn ps-btn--ghost"
                                        >
                                            ↺ Refresh
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Message */}
                            {message && (
                                <div className={`ps-msg ${
                                    message.includes('Error') || message.includes('error') ? 'ps-msg--error' :
                                    message.includes('Updated') || message.includes('success') || message.includes('updated') ? 'ps-msg--success' :
                                    'ps-msg--info'
                                }`}>
                                    {message}
                                </div>
                            )}

                            {/* Stats */}
                            <div className="ps-stats">
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--blue">{totalPackages}</div>
                                    <div className="ps-stat-label">Total Packages</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--green">{scannedPackages}</div>
                                    <div className="ps-stat-label">Scanned</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--amber">{pendingPackages}</div>
                                    <div className="ps-stat-label">Pending</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--muted">
                                        {totalPackages > 0 ? `${Math.round((scannedPackages / totalPackages) * 100)}%` : '0%'}
                                    </div>
                                    <div className="ps-stat-label">Completion</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--purple">{stats.totalScanningMinutes}</div>
                                    <div className="ps-stat-label">Total Time (min)</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--cyan">{stats.avgPerPackageMinutes}</div>
                                    <div className="ps-stat-label">Avg per Order (min)</div>
                                </div>
                            </div>

                            {/* Table */}
                            <div className="ps-table-wrap">
                                <div className="ps-filter-bar">
                                    <div className="ps-filter-field" style={{ flex: '1 1 240px' }}>
                                        <label className="ps-filter-label" htmlFor="scan-search">Search</label>
                                        <input
                                            id="scan-search"
                                            type="text"
                                            placeholder="Order # or Tracking #…"
                                            value={searchQuery}
                                            onChange={e => setSearchQuery(e.target.value)}
                                            onFocus={handleSearchFocus}
                                            onBlur={handleSearchBlur}
                                            className="ps-filter-input"
                                        />
                                    </div>
                                    <div className="ps-filter-field">
                                        <label className="ps-filter-label" htmlFor="scan-service">Service</label>
                                        <select
                                            id="scan-service"
                                            value={filterService}
                                            onChange={e => setFilterService(e.target.value)}
                                            onFocus={handleFilterFocus}
                                            onBlur={handleFilterBlur}
                                            className="ps-filter-select"
                                        >
                                            <option value="All">All Services</option>
                                            <option value="UPS">UPS</option>
                                            <option value="USPS">USPS</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="ps-filter-field">
                                        <label className="ps-filter-label" htmlFor="scan-status">Status</label>
                                        <select
                                            id="scan-status"
                                            value={filterStatus}
                                            onChange={e => setFilterStatus(e.target.value)}
                                            onFocus={handleFilterFocus}
                                            onBlur={handleFilterBlur}
                                            className="ps-filter-select"
                                        >
                                            <option value="All">All Statuses</option>
                                            <option value="Scanned">Scanned</option>
                                            <option value="Not Scanned">Not Scanned</option>
                                            <option value="Resend">↺ Resend Only</option>
                                        </select>
                                    </div>
                                    <div className="ps-filter-count">
                                        {filteredPackages.length} of {packages.length}
                                    </div>
                                </div>

                                {loading ? (
                                    <div className="ps-loading"><div className="ps-spinner" /> Loading packages…</div>
                                ) : filteredPackages.length > 0 ? (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className="ps-table">
                                            <thead>
                                                <tr>
                                                    <th>Order #</th>
                                                    <th>Tracking #</th>
                                                    <th>Service</th>
                                                    <th className="ps-th-sortable" onClick={() => handleSort('order_date')}>Order Date <SortIcon field="order_date" /></th>
                                                    <th className="ps-th-sortable" onClick={() => handleSort('scanned_at')}>Scan Time <SortIcon field="scanned_at" /></th>
                                                    <th>Status</th>
                                                    <th>Assembly</th>
                                                    <th style={{ width: 48 }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredPackages.map((pkg, index) => (
                                                    <tr
                                                        key={pkg.id || index}
                                                        className={
                                                            pkg.is_resend ? 'ps-row--resend' :
                                                            pkg.status === 'Scanned' ? 'ps-row--scanned' : 'ps-row--pending'
                                                        }
                                                    >
                                                        <td>
                                                            <span className="ps-order-link" onClick={() => openOrderPopup(pkg.order_number, pkg.tracking_number, filteredPackages.map(p => ({ order_number: p.order_number, tracking_number: p.tracking_number })), Object.fromEntries(filteredPackages.map(p => [p.order_number + '|' + p.tracking_number, p.order_date])))}>{pkg.order_number}</span>
                                                            {pkg.is_resend ? (
                                                                <span className="ps-resend-tag">↺ Resend</span>
                                                            ) : null}
                                                            {amazonOrders.has(pkg.order_number) ? (
                                                                <span className="ps-amazon-tag">Amazon</span>
                                                            ) : null}
                                                        </td>
                                                        <td><span className="ps-mono">{pkg.tracking_number}</span></td>
                                                        <td>{pkg.service || '—'}</td>
                                                        <td>{formatDateOnly(pkg.order_date)}</td>
                                                        <td>{pkg.status === 'Scanned' && pkg.scanned_at ? formatScanTimeEST(pkg.scanned_at) : '—'}</td>
                                                        <td>
                                                            <span className={`ps-badge ${pkg.status === 'Scanned' ? 'ps-badge--green' : 'ps-badge--amber'}`}>
                                                                {pkg.status === 'Scanned' ? '✓' : '○'} {pkg.status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {(() => {
                                                                const s = assemblyStatuses[pkg.order_number];
                                                                if (s === 'complete')    return <span className="ps-asm-badge ps-asm-badge--done">Complete</span>;
                                                                if (s === 'in_progress') return <span className="ps-asm-badge ps-asm-badge--progress">In Progress</span>;
                                                                return <span className="ps-asm-badge ps-asm-badge--none">—</span>;
                                                            })()}
                                                        </td>
                                                        <td>
                                                            {pkg.status === 'Scanned' && (
                                                                <button
                                                                    className="ps-resend-btn"
                                                                    onClick={() => handleResend(pkg)}
                                                                    title="Mark for resend"
                                                                >↺</button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="ps-empty">
                                        <div className="ps-empty-icon"></div>
                                        No packages match your filters
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {/* ═══════════════ TRACKING TAB ═══════════════ */}
                    {activeTab === 'tracking' && (
                        <>
                            <div className="ps-panel">
                                <div className="ps-panel-row">
                                    <span className="ps-date-label">Ship Date:</span>
                                    <input
                                        type="date"
                                        value={shipDate}
                                        onChange={handleDateChange}
                                        className="ps-date-input"
                                        max={new Date().toISOString().split('T')[0]}
                                    />
                                    <button onClick={handleTodayButtonClick} className="ps-btn ps-btn--cyan">
                                        Today
                                    </button>
                                    <div className="ps-btn-group" style={{ marginLeft: 'auto' }}>
                                        <button
                                            onClick={async () => {
                                                try {
                                                    const response = await api.get(`/api/tracking/api-status`);
                                                    alert(`API Status:\nUSPS: ${response.data.USPS.available ? 'Available' : 'Not available'}\nUPS: ${response.data.UPS.available ? 'Available' : 'Not available'}`);
                                                } catch { alert('Error checking API status'); }
                                            }}
                                            className="ps-btn ps-btn--ghost ps-btn--sm"
                                        >
                                            API Status
                                        </button>
                                        <button
                                            onClick={async () => {
                                                try {
                                                    await api.post(`/api/tracking/clear-cache`);
                                                    alert('Cache cleared');
                                                    fetchTrackingData();
                                                } catch { alert('Error clearing cache'); }
                                            }}
                                            className="ps-btn ps-btn--ghost ps-btn--sm"
                                            style={{ color: 'var(--ps-red)' }}
                                        >
                                            Clear Cache
                                        </button>
                                        <button
                                            onClick={handleRefreshTracking}
                                            disabled={trackingLoading}
                                            className="ps-btn ps-btn--blue"
                                            style={{ marginLeft: 0 }}
                                        >
                                            {trackingLoading ? 'Refreshing…' : '↺ Refresh Tracking'}
                                        </button>
                                    </div>
                                </div>
                                {trackingLastUpdated && (
                                    <div className="ps-last-updated">Last updated: {trackingLastUpdated}</div>
                                )}
                            </div>

                            {/* Tracking Stats */}
                            <div className="ps-stats">
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--red">{notMovingPackages}</div>
                                    <div className="ps-stat-label">Not Moving</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--cyan">{inTransitPackages}</div>
                                    <div className="ps-stat-label">In Transit</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--green">{deliveredPackages}</div>
                                    <div className="ps-stat-label">Delivered</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--muted">{trackingData.length}</div>
                                    <div className="ps-stat-label">Total Tracked</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--green">{warehouseScannedPackages}</div>
                                    <div className="ps-stat-label">WH Scanned</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--red">{warehouseNotScannedPackages}</div>
                                    <div className="ps-stat-label">WH Not Scanned</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--amber">
                                        {trackingData.length > 0 ? `${Math.round((notMovingPackages / trackingData.length) * 100)}%` : '0%'}
                                    </div>
                                    <div className="ps-stat-label">Not Moving %</div>
                                </div>
                            </div>

                            {/* Status Pills */}
                            {trackingStatusFilters.length > 0 && (
                                <div className="ps-pills">
                                    {trackingStatusFilters.map(status => (
                                        <button
                                            key={status}
                                            className={`ps-pill${selectedStatusFilter === status ? ' ps-pill--active' : ''}`}
                                            onClick={() => setSelectedStatusFilter(status)}
                                        >
                                            {getTrackingStatusIcon(status)} {status === 'all' ? 'All Statuses' : status}
                                        </button>
                                    ))}
                                </div>
                            )}

                            {/* Tracking Table */}
                            <div className="ps-table-wrap">
                                <div className="ps-filter-bar">
                                    <div className="ps-filter-field" style={{ flex: '1 1 240px' }}>
                                        <label className="ps-filter-label">Search</label>
                                        <input
                                            type="text"
                                            placeholder="Order # or Tracking #…"
                                            value={trackingSearchQuery}
                                            onChange={e => setTrackingSearchQuery(e.target.value)}
                                            onFocus={handleSearchFocus}
                                            onBlur={handleSearchBlur}
                                            className="ps-filter-input"
                                        />
                                    </div>
                                    <div className="ps-filter-field">
                                        <label className="ps-filter-label">Carrier</label>
                                        <select
                                            value={filterTrackingCarrier}
                                            onChange={e => setFilterTrackingCarrier(e.target.value)}
                                            onFocus={handleFilterFocus}
                                            onBlur={handleFilterBlur}
                                            className="ps-filter-select"
                                        >
                                            <option value="All">All Carriers</option>
                                            <option value="UPS">UPS</option>
                                            <option value="USPS">USPS</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="ps-filter-field">
                                        <label className="ps-filter-label">Warehouse</label>
                                        <select
                                            value={filterTrackingWarehouseStatus}
                                            onChange={e => setFilterTrackingWarehouseStatus(e.target.value)}
                                            onFocus={handleFilterFocus}
                                            onBlur={handleFilterBlur}
                                            className="ps-filter-select"
                                        >
                                            <option value="All">All Statuses</option>
                                            <option value="Scanned">Scanned</option>
                                            <option value="Not Scanned">Not Scanned</option>
                                        </select>
                                    </div>
                                    <div className="ps-filter-count">
                                        {filteredTrackingData.length} of {trackingData.length}
                                    </div>
                                </div>

                                {trackingLoading ? (
                                    <div className="ps-loading"><div className="ps-spinner" /> Loading tracking data…</div>
                                ) : filteredTrackingData.length > 0 ? (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className="ps-table">
                                            <thead>
                                                <tr>
                                                    <th>Order #</th>
                                                    <th>Tracking #</th>
                                                    <th>Service</th>
                                                    <th>Order Date</th>
                                                    <th>Scanned Date</th>
                                                    <th>Warehouse</th>
                                                    <th>Tracking Status</th>
                                                    <th>Last Update</th>
                                                    <th>Description</th>
                                                    <th>Est. Delivery</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredTrackingData.map((item, index) => (
                                                    <tr
                                                        key={item.id || index}
                                                        className={
                                                            item.movement === 'delivered' ? 'ps-row--delivered' :
                                                            item.movement === 'not_moving' ? 'ps-row--notmoving' : 'ps-row--pending'
                                                        }
                                                    >
                                                        <td>
                                                            <span className="ps-order-link" onClick={() => openOrderPopup(item.order_number, item.tracking_number, filteredTrackingData.map(i => ({ order_number: i.order_number, tracking_number: i.tracking_number })), Object.fromEntries(filteredTrackingData.map(i => [i.order_number + '|' + i.tracking_number, i.order_date])))}>{item.order_number}</span>
                                                            {item.is_resend ? <span className="ps-resend-tag">↺ Resend</span> : null}
                                                        </td>
                                                        <td><span className="ps-mono">{item.tracking_number}</span></td>
                                                        <td>{item.service || '—'}</td>
                                                        <td>{formatDateOnly(item.order_date)}</td>
                                                        <td>{formatScanTimeEST(item.scanned_date)}</td>
                                                        <td>
                                                            <span className={`ps-badge ${item.warehouse_status === 'Scanned' ? 'ps-badge--green' : 'ps-badge--amber'}`}>
                                                                {item.warehouse_status === 'Scanned' ? '✓' : '○'} {item.warehouse_status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className={`ps-tracking-badge ${getTrackingStatusClass(item.tracking_status)}`}>
                                                                {getTrackingStatusIcon(item.tracking_status)} {item.tracking_status}
                                                            </span>
                                                        </td>
                                                        <td>{formatScanTimeEST(item.last_update)}</td>
                                                        <td>{item.status_description}</td>
                                                        <td>{item.estimated_delivery ? formatShipDateEST(item.estimated_delivery) : '—'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="ps-empty">
                                        <div className="ps-empty-icon">📡</div>
                                        No tracking data for selected filters
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {/* ═══════════════ STUCK TAB ═══════════════ */}
                    {activeTab === 'stuck' && (
                        <>
                            <div className="ps-stuck-header">
                                ⚠️ Stuck Packages Monitor
                            </div>

                            <div className="ps-panel">
                                <div className="ps-panel-row">
                                    <span className="ps-date-label">Older than (days):</span>
                                    <input
                                        type="number"
                                        value={stuckDaysFilter}
                                        onChange={e => setStuckDaysFilter(e.target.value)}
                                        min="1"
                                        max="30"
                                        className="ps-date-input"
                                        style={{ width: '80px' }}
                                    />
                                    <span className="ps-date-label" style={{ marginLeft: '12px' }}>From:</span>
                                    <input
                                        type="date"
                                        value={stuckDateFrom}
                                        onChange={e => setStuckDateFrom(e.target.value)}
                                        className="ps-date-input"
                                    />
                                    <span className="ps-date-label">To:</span>
                                    <input
                                        type="date"
                                        value={stuckDateTo}
                                        onChange={e => setStuckDateTo(e.target.value)}
                                        className="ps-date-input"
                                    />
                                    <button
                                        onClick={fetchStuckPackages}
                                        disabled={stuckLoading}
                                        className="ps-btn ps-btn--blue"
                                        style={{ marginLeft: 0 }}
                                    >
                                        {stuckLoading ? 'Loading…' : '↺ Load Stuck'}
                                    </button>
                                    <button
                                        onClick={() => { setStuckDateFrom(''); setStuckDateTo(''); setStuckDaysFilter(1); fetchStuckPackages(); }}
                                        className="ps-btn ps-btn--ghost ps-btn--sm"
                                        style={{ marginLeft: 'auto' }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>

                            {/* Stuck Stats */}
                            <div className="ps-stats">
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--red">{stuckStats.stuck || 0}</div>
                                    <div className="ps-stat-label">Stuck Packages</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--blue">{stuckStats.total || 0}</div>
                                    <div className="ps-stat-label">Total Checked</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--amber">{stuckStats.percentage || 0}%</div>
                                    <div className="ps-stat-label">Stuck %</div>
                                </div>
                                <div className="ps-stat-card">
                                    <div className="ps-stat-value ps-stat-value--muted">{stuckDaysFilter}</div>
                                    <div className="ps-stat-label">Days Threshold</div>
                                </div>
                                {Object.keys(stuckStats.by_carrier || {}).map(carrier => (
                                    <div key={carrier} className="ps-stat-card">
                                        <div className="ps-stat-value">{stuckStats.by_carrier[carrier]}</div>
                                        <div className="ps-stat-label">{carrier}</div>
                                    </div>
                                ))}
                            </div>

                            {/* Stuck Table */}
                            <div className="ps-table-wrap">
                                <div className="ps-filter-bar">
                                    <div className="ps-filter-field" style={{ flex: '1 1 240px' }}>
                                        <label className="ps-filter-label">Search</label>
                                        <input
                                            id="stuck-search-input"
                                            type="text"
                                            placeholder="Order # or Tracking #…"
                                            value={stuckSearchQuery}
                                            onChange={e => setStuckSearchQuery(e.target.value)}
                                            className="ps-filter-input"
                                        />
                                    </div>
                                    <div className="ps-filter-field">
                                        <label className="ps-filter-label">Carrier</label>
                                        <select
                                            value={stuckCarrierFilter}
                                            onChange={e => setStuckCarrierFilter(e.target.value)}
                                            className="ps-filter-select"
                                        >
                                            <option value="All">All Carriers</option>
                                            <option value="UPS">UPS</option>
                                            <option value="USPS">USPS</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="ps-filter-field">
                                        <label className="ps-filter-label">Warehouse</label>
                                        <select
                                            value={stuckWarehouseFilter}
                                            onChange={e => setStuckWarehouseFilter(e.target.value)}
                                            className="ps-filter-select"
                                        >
                                            <option value="All">All Statuses</option>
                                            <option value="Scanned">Scanned</option>
                                            <option value="Not Scanned">Not Scanned</option>
                                        </select>
                                    </div>
                                    <div className="ps-filter-count">
                                        {getFilteredStuckPackages().length} of {stuckPackages.length}
                                    </div>
                                </div>

                                {stuckLoading ? (
                                    <div className="ps-loading"><div className="ps-spinner" /> Loading stuck packages…</div>
                                ) : getFilteredStuckPackages().length > 0 ? (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className="ps-table">
                                            <thead>
                                                <tr>
                                                    <th>Order #</th>
                                                    <th>Tracking #</th>
                                                    <th>Service</th>
                                                    <th>Order Date</th>
                                                    <th>Days Stuck</th>
                                                    <th>Warehouse</th>
                                                    <th>Tracking Status</th>
                                                    <th>Carrier</th>
                                                    <th>Last Update</th>
                                                    <th>Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getFilteredStuckPackages().map((item, index) => (
                                                    <tr
                                                        key={item.id || index}
                                                        className={
                                                            item.days_stuck >= 3 ? 'ps-row--stuck-3' :
                                                            item.days_stuck >= 2 ? 'ps-row--stuck-2' : 'ps-row--pending'
                                                        }
                                                    >
                                                        <td><span className="ps-order-link" onClick={() => { const sp = getFilteredStuckPackages(); openOrderPopup(item.order_number, item.tracking_number, sp.map(i => ({ order_number: i.order_number, tracking_number: i.tracking_number })), Object.fromEntries(sp.map(i => [i.order_number + '|' + i.tracking_number, i.order_date]))); }}>{item.order_number}</span></td>
                                                        <td><span className="ps-mono">{item.tracking_number}</span></td>
                                                        <td>{item.service || '—'}</td>
                                                        <td>{formatDateOnly(item.order_date)}</td>
                                                        <td>
                                                            <span className={`ps-days-badge ${
                                                                item.days_stuck >= 3 ? 'ps-days-badge--danger' :
                                                                item.days_stuck >= 2 ? 'ps-days-badge--warn' : 'ps-days-badge--ok'
                                                            }`}>
                                                                {item.days_stuck}d
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className={`ps-badge ${item.warehouse_status === 'Scanned' ? 'ps-badge--green' : 'ps-badge--amber'}`}>
                                                                {item.warehouse_status === 'Scanned' ? '✓' : '○'} {item.warehouse_status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className={`ps-tracking-badge ${getTrackingStatusClass(item.tracking_status)}`}>
                                                                {getTrackingStatusIcon(item.tracking_status)} {item.tracking_status}
                                                            </span>
                                                        </td>
                                                        <td>{item.carrier || '—'}</td>
                                                        <td>{formatScanTimeEST(item.last_update)}</td>
                                                        <td>{item.status_description}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="ps-empty">
                                        <div className="ps-empty-icon">🎉</div>
                                        {stuckPackages.length === 0
                                            ? 'Click "Load Stuck" to check for stuck packages'
                                            : 'No stuck packages match your filters'}
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {/* ═══════════════ SS STOCK TAB ═══════════════ */}
                    {activeTab === 'ssstock' && (
                        <>
                            {/* Materials Write-off Confirm Popup (manual add, all deductible types) */}
                            {bagPopup && (() => {
                                const isSet = bagPopup.item.product_type === 'set';
                                const needsBag = ['wildmicr', 'fertilizer'].includes(bagPopup.item.product_type);
                                const info = bagPopup.info;
                                const deduct = info ? Math.round(bagPopup.diff * info.per_unit_lb * 10000) / 10000 : 0;
                                const after = info ? Math.round((info.bag_weight - deduct) * 10000) / 10000 : 0;
                                return (
                                    <div className="ps-modal-overlay" onClick={() => !bagPopup.busy && setBagPopup(null)}>
                                        <div className="ps-modal" onClick={e => e.stopPropagation()}>
                                            <div className="ps-modal-header">
                                                <h3 className="ps-modal-title">Confirm Materials Write-off</h3>
                                                <button className="ps-modal-close" onClick={() => setBagPopup(null)}>×</button>
                                            </div>
                                            <div className="ps-modal-body">
                                                <p className="ps-modal-hint">
                                                    <strong>{bagPopup.item.product_name}</strong> — adding <strong>{bagPopup.diff}</strong> pcs to SS Stock.
                                                </p>
                                                {isSet && (
                                                    <p className="ps-modal-hint">
                                                        Set materials for {bagPopup.diff} pcs will be written off:
                                                        composition seed packets — and Master Bag, Mini Tools, Desiccant Bag
                                                        if this set includes them (multipacks don't).
                                                    </p>
                                                )}
                                                {!isSet && !needsBag && (
                                                    <p className="ps-modal-hint">
                                                        Finished packets for {bagPopup.diff} pcs will be written off from WH inventory.
                                                    </p>
                                                )}
                                                {needsBag && (
                                                    <>
                                                        <label className="ps-filter-label">Bag number</label>
                                                        <div style={{ display: 'flex', gap: 8 }}>
                                                            <input
                                                                className="ps-filter-input"
                                                                value={bagPopup.bag}
                                                                onChange={e => setBagPopup(p => ({ ...p, bag: e.target.value, info: null, error: '' }))}
                                                                onKeyDown={e => { if (e.key === 'Enter') checkBagInfo(); }}
                                                                placeholder="Scan or type bag #"
                                                                autoFocus
                                                                disabled={bagPopup.skipOld}
                                                            />
                                                            <button className="ps-btn ps-btn--ghost" onClick={checkBagInfo} disabled={bagPopup.busy || bagPopup.skipOld || !bagPopup.bag.trim()}>
                                                                Check
                                                            </button>
                                                        </div>
                                                        {info && !bagPopup.skipOld && (
                                                            <table className="ss-history-table" style={{ marginTop: 12 }}>
                                                                <tbody>
                                                                    <tr><td>Material</td><td><strong>{info.material || '—'}</strong></td></tr>
                                                                    <tr><td>Per unit</td><td>{info.per_unit_lb} lb × {bagPopup.diff} pcs</td></tr>
                                                                    <tr><td>Bag weight now</td><td>{info.bag_weight} lb</td></tr>
                                                                    <tr><td>Write off</td><td><span className="ss-history-minus">−{deduct} lb</span></td></tr>
                                                                    <tr><td>Weight after</td><td><strong className={after < 0 ? 'ss-history-minus' : ''}>{after} lb</strong></td></tr>
                                                                </tbody>
                                                            </table>
                                                        )}
                                                    </>
                                                )}
                                                <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, cursor: 'pointer' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={!!bagPopup.skipOld}
                                                        onChange={e => setBagPopup(p => ({ ...p, skipOld: e.target.checked, info: null, error: '' }))}
                                                    />
                                                    Old stock — current materials were not used (skip write-off)
                                                </label>
                                                {bagPopup.error && <div className="ps-modal-msg ps-modal-msg--error">{bagPopup.error}</div>}
                                            </div>
                                            <div className="ps-modal-footer">
                                                <button
                                                    className="ps-btn ps-btn--primary"
                                                    onClick={confirmBagPopup}
                                                    disabled={bagPopup.busy || (needsBag && !bagPopup.skipOld && (!info || after < 0))}
                                                >
                                                    {bagPopup.busy ? 'Saving…' : bagPopup.skipOld ? 'Confirm (no write-off)' : 'Confirm & Write Off'}
                                                </button>
                                                <button className="ps-btn ps-btn--ghost" onClick={() => setBagPopup(null)}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}

                            {/* History Popup */}
                            {historyPopup && (
                                <div className="ps-modal-overlay" onClick={() => setHistoryPopup(null)}>
                                    <div className="ss-history-modal" onClick={e => e.stopPropagation()}>
                                        <div className="ps-modal-header">
                                            <div>
                                                <h3 className="ps-modal-title">
                                                    <FontAwesomeIcon icon={faClockRotateLeft} style={{ marginRight: 8, color: 'var(--ps-text-muted)' }} />
                                                    {historyPopup.productName}
                                                </h3>
                                                <span className="ss-history-sku-tag">{historyPopup.sku}</span>
                                            </div>
                                            <button className="ps-modal-close" onClick={() => setHistoryPopup(null)}>×</button>
                                        </div>
                                        <div className="ss-history-body">
                                            {historyLoading ? (
                                                <div className="ps-loading" style={{ padding: 24 }}><div className="ps-spinner" /> Loading history…</div>
                                            ) : historyPopup.items.length === 0 ? (
                                                <div className="ps-empty" style={{ padding: 32 }}>No history yet</div>
                                            ) : (
                                                <table className="ss-history-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Date &amp; Time</th>
                                                            <th>Source</th>
                                                            <th>Box / Order</th>
                                                            <th>Before</th>
                                                            <th>Change</th>
                                                            <th>After</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {historyPopup.items.map(h => (
                                                            <tr key={h.id}>
                                                                <td className="ss-history-date">
                                                                    {new Date(h.created_at).toLocaleString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })}
                                                                </td>
                                                                <td>
                                                                    <span className={`ps-badge ${h.source === 'box_add' ? 'ps-badge--green' : h.source === 'wh_transfer' ? 'ps-badge--green' : h.source === 'order_scan' ? 'ps-badge--cyan' : h.source === 'scan_undo' ? 'ps-badge--orange' : 'ps-badge--muted'}`}>
                                                                        {h.source === 'box_add' ? 'Box Added' : h.source === 'wh_transfer' ? 'WH Transfer' : h.source === 'order_scan' ? 'Order Scan' : h.source === 'scan_undo' ? 'Scan Undo' : 'Manual Edit'}
                                                                    </span>
                                                                </td>
                                                                <td><span className="ps-mono" style={{ fontSize: 12 }}>{h.box_number || h.order_number || '—'}</span></td>
                                                                <td className="ss-history-num" style={{ color: 'var(--ps-text-muted)' }}>{h.qty_before}</td>
                                                                <td className="ss-history-num">
                                                                    <span className={h.change_qty > 0 ? 'ss-history-plus' : 'ss-history-minus'}>
                                                                        {h.change_qty > 0 ? '+' : ''}{h.change_qty}
                                                                    </span>
                                                                </td>
                                                                <td className="ss-history-num"><strong>{h.qty_after}</strong></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Add Boxes Popup */}
                            {ssStockAddPopup && (
                                <div className="ps-modal-overlay" onClick={() => { setSsStockAddPopup(false); setSsStockSaveMsg(''); setSsStockBoxText(''); }}>
                                    <div className="ps-modal" onClick={e => e.stopPropagation()}>
                                        <div className="ps-modal-header">
                                            <h3 className="ps-modal-title">Add Boxes to SS Stock</h3>
                                            <button className="ps-modal-close" onClick={() => { setSsStockAddPopup(false); setSsStockSaveMsg(''); setSsStockBoxText(''); }}>×</button>
                                        </div>
                                        <div className="ps-modal-body">
                                            <p className="ps-modal-hint">Scan QR codes from boxes. Format: <code>Name, SKU, BOX#number/qty</code></p>
                                            <textarea
                                                className="ps-modal-textarea"
                                                value={ssStockBoxText}
                                                onChange={e => setSsStockBoxText(e.target.value)}
                                                placeholder="Scan box QR codes here..."
                                                rows={8}
                                                autoFocus
                                            />
                                            {ssStockSaveMsg && (
                                                <div className={`ps-modal-msg ${ssStockSaveMsg.includes('Error') || ssStockSaveMsg.includes('No valid') ? 'ps-modal-msg--error' : 'ps-modal-msg--ok'}`}>
                                                    {ssStockSaveMsg}
                                                </div>
                                            )}
                                        </div>
                                        <div className="ps-modal-footer">
                                            <button
                                                className="ps-btn ps-btn--primary"
                                                onClick={handleAddBoxesToSsStock}
                                                disabled={ssStockSaving || !ssStockBoxText.trim()}
                                            >
                                                {ssStockSaving ? 'Saving…' : 'Recognize Boxes & Add to Stock'}
                                            </button>
                                            <button className="ps-btn ps-btn--ghost" onClick={() => { setSsStockAddPopup(false); setSsStockSaveMsg(''); setSsStockBoxText(''); }}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="ps-table-wrap">
                                <div className="ps-filter-bar">
                                    <div className="ps-filter-field" style={{ flex: '1 1 240px' }}>
                                        <label className="ps-filter-label">Search</label>
                                        <input
                                            type="text"
                                            placeholder="SKU, GTIN or product name…"
                                            value={ssStockSearch}
                                            onChange={e => setSsStockSearch(e.target.value)}
                                            className="ps-filter-input"
                                        />
                                    </div>
                                    <div className="ps-filter-field">
                                        <label className="ps-filter-label">Brand</label>
                                        <select
                                            value={ssStockBrandFilter}
                                            onChange={e => setSsStockBrandFilter(e.target.value)}
                                            className="ps-filter-select"
                                        >
                                            {ssStockBrands.map(b => (
                                                <option key={b} value={b}>{b}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="ps-filter-count">
                                        {getSsStockFiltered().length} of {ssStockData.length}
                                    </div>
                                    <button className="ps-btn ps-btn--primary" style={{ marginLeft: 'auto' }} onClick={() => { setSsStockAddPopup(true); setSsStockSaveMsg(''); }}>
                                        + Add Boxes
                                    </button>
                                    <button className="ps-btn ps-btn--ghost" onClick={fetchSsStock} disabled={ssStockLoading}>
                                        {ssStockLoading ? 'Loading…' : 'Refresh'}
                                    </button>
                                </div>

                                {ssStockLoading ? (
                                    <div className="ps-loading"><div className="ps-spinner" /> Loading SS Stock…</div>
                                ) : getSsStockFiltered().length > 0 ? (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className="ps-table">
                                            <thead>
                                                <tr>
                                                    <th>Brand</th>
                                                    <th>Product Name</th>
                                                    <th>SKU</th>
                                                    <th>GTIN</th>
                                                    <th>Type</th>
                                                    <th>SS Stock</th>
                                                    <th>WH Stock</th>
                                                    <th>Last Updated</th>
                                                    <th style={{ width: 48 }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getSsStockFiltered().map(item => (
                                                    <tr key={item.sku}>
                                                        <td>{item.brand_name || '—'}</td>
                                                        <td>{item.product_name || '—'}</td>
                                                        <td><span className="ps-mono">{item.sku}</span></td>
                                                        <td><span className="ps-mono">{item.gtin || '—'}</span></td>
                                                        <td><span className="ps-badge ps-badge--muted">
                                                            {item.product_type === 'wildmicr' ? 'Wildflowers & Microgreens'
                                                            : item.product_type === 'set' ? 'Sets'
                                                            : item.product_type === 'individual' ? 'Small Bags'
                                                            : item.product_type === 'readyproduct' ? 'Ready Products'
                                                            : item.product_type === 'kit' ? 'Kits'
                                                            : item.product_type === 'fertilizer' ? 'Fertilizers'
                                                            : item.product_type || '—'}
                                                        </span></td>
                                                        <td>
                                                            {editingId === item.sku ? (
                                                                <span className="ss-qty-edit">
                                                                    <input
                                                                        type="number"
                                                                        className="ss-qty-input"
                                                                        value={editingQty}
                                                                        min="0"
                                                                        onChange={e => setEditingQty(e.target.value)}
                                                                        onKeyDown={e => { if (e.key === 'Enter') saveEditQty(item); if (e.key === 'Escape') cancelEditQty(); }}
                                                                        autoFocus
                                                                    />
                                                                    <button className="ss-qty-btn ss-qty-btn--ok" onClick={() => saveEditQty(item)} title="Save">
                                                                        <FontAwesomeIcon icon={faCheck} />
                                                                    </button>
                                                                    <button className="ss-qty-btn ss-qty-btn--cancel" onClick={cancelEditQty} title="Cancel">
                                                                        <FontAwesomeIcon icon={faXmark} />
                                                                    </button>
                                                                </span>
                                                            ) : (
                                                                <span className="ss-qty-view" onClick={() => startEditQty(item)} title="Click to edit">
                                                                    <strong>{item.quantity}</strong>
                                                                    <FontAwesomeIcon icon={faPen} className="ss-qty-pen" />
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>{item.wh_quantity ?? 0}</td>
                                                        <td>{item.updated_at ? new Date(item.updated_at).toLocaleString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }) : '—'}</td>
                                                        <td>
                                                            <button className="ss-history-btn" onClick={() => openHistory(item.sku, item.product_name)} title="View history">
                                                                <FontAwesomeIcon icon={faClockRotateLeft} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="ps-empty">
                                        <div className="ps-empty-icon"></div>
                                        {ssStockData.length === 0 ? 'No items in SS Stock yet. Use "+ Add Boxes" to add stock.' : 'No items match your filters.'}
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default OrdersPackagesPage;